var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.378e-06 90.0002V295C-0.00131202 299.766 0.936261 304.485 2.75879 308.889C4.58132 313.292 7.25316 317.293 10.6221 320.664C13.991 324.035 17.9909 326.709 22.3933 328.534C26.7957 330.359 31.5144 331.299 36.28 331.3H228.79C233.558 331.302 238.279 330.364 242.685 328.54C247.09 326.716 251.093 324.043 254.465 320.672C257.836 317.301 260.511 313.299 262.336 308.894C264.161 304.489 265.1 299.768 265.1 295V36.3303C265.1 31.5624 264.161 26.8413 262.336 22.4365C260.511 18.0318 257.836 14.0297 254.465 10.6588C251.093 7.28786 247.09 4.61425 242.685 2.79059C238.279 0.966932 233.558 0.0289614 228.79 0.0302748H90.02L18.8401 71.1802L1.378e-06 90.0002Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9998L18.8401 71.1598L90.02 0.00977803H228.79C233.561 0.00583417 238.286 0.942517 242.695 2.76625C247.104 4.58998 251.11 7.26498 254.485 10.6383C257.859 14.0115 260.535 18.0169 262.36 22.4253C264.185 26.8337 265.123 31.5586 265.12 36.3298V120.69H0.0200195L0 89.9998Z",
    fill: "#A65AA5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9901L44.4302 99.8101C53.861 101.754 63.6778 99.8732 71.7224 94.5814C79.767 89.2896 85.3809 81.0199 87.3301 71.5901L89.1802 61.4102C88.5954 64.2189 87.6615 66.9433 86.4001 69.5201C83.4313 75.6575 78.7922 80.8335 73.0154 84.4542C67.2385 88.0749 60.558 89.9936 53.7402 89.9901H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99H53.7402C60.558 89.9935 67.2385 88.0748 73.0154 84.4541C78.7922 80.8334 83.4313 75.6574 86.4001 69.52C87.6615 66.9432 88.5954 64.2187 89.1802 61.41C89.7418 58.8754 90.02 56.2861 90.01 53.69V0L18.8401 71.16L0 89.99Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.799 128.55H170.469V150.88H192.799V128.55Z",
    fill: "#A65AA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M215.127 150.88H192.797V173.21H215.127V150.88Z",
    fill: "#A65AA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.799 173.21H170.469V195.54H192.799V173.21Z",
    fill: "#A65AA5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.127 195.54H192.797V217.87H215.127V195.54Z",
    fill: "#A65AA5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.799 217.87H170.469V240.2H192.799V217.87Z",
    fill: "#A65AA5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.469 251.33V317.43H215.119V251.33H170.469ZM203.969 283.91H181.629V261.53H203.969V283.91Z",
    fill: "#A65AA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.3ed3f7076d9c525c05687aef6dbf07a2.svg";
export { ForwardRef as ReactComponent };